// topologyApi — wire to GET /v1/tenants/topology.
//
// Backs the 視覺總覽 page. Returns flat arrays for each entity in the
// tenant hierarchy; the page composes the React Flow graph client-side.

import { apiFetch } from "../../lib/api-client.js";

export interface TopologyTenant {
  id: string;
  name: string | null;
  slug: string | null;
}

export interface TopologyClient {
  id: string;
  name: string;
  status: string;
  contact_name: string | null;
  site_count: number;
}

export interface TopologySite {
  id: string;
  client_id: string;
  client_name: string | null;
  name: string;
  address: string | null;
  status: string;
  risk_level: string;
  location_count: number;
}

export interface TopologyBuilding {
  id: string;
  site_id: string;
  name: string;
  display_order: number;
  status: string;
}

export interface TopologyFloor {
  id: string;
  building_id: string | null;
  site_id: string;
  name: string;
  display_label: string | null;
  ordinal: number;
}

export interface TopologyLocation {
  id: string;
  site_id: string;
  building_id: string | null;
  floor_id: string | null;
  code: string | null;
  label: string | null;
  status: string;
  risk_level: string;
  ntag_bound: number;
}

export interface TopologyRoute {
  id: string;
  site_id: string;
  name: string;
  sequence_strict: number;
  status: string;
  /** Location IDs in sequence order. */
  location_ids: string[];
}

export interface TopologyTask {
  id: string;
  name: string;
  description_short: string | null;
  verify_device: number;
  verify_face: number;
  requires_signature: number;
}

export interface TopologyAssignment {
  id: string;
  task_id: string;
  location_id: string;
  route_id: string | null;
  rrule: string;
  duration_minutes: number;
  target_kind: string;
  target_value: string;
  status: string;
}

export interface TopologyResponse {
  tenant: TopologyTenant;
  clients: TopologyClient[];
  sites: TopologySite[];
  buildings: TopologyBuilding[];
  floors: TopologyFloor[];
  locations: TopologyLocation[];
  routes: TopologyRoute[];
  tasks: TopologyTask[];
  assignments: TopologyAssignment[];
  correlation_id: string | null;
}

export async function fetchTopology(tenantId?: string | null): Promise<TopologyResponse> {
  const qs = tenantId ? `?tenant_id=${encodeURIComponent(tenantId)}` : "";
  const r = await apiFetch(`/v1/tenants/topology${qs}`, { credentials: "include" });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return (await r.json()) as TopologyResponse;
}
